module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/benefits/background-203181bb6daede2ee39e4b92973ff127.svg";